<template>
  <div class="d-flex flex-column vh-100" >
    <b-navbar toggleable="lg"
              :class="{
                        'navbar-amarela': ambiente === 'dev' || ambiente === 'hml',
                        'navbar-branca': ambiente !== 'dev' && ambiente !== 'hml'
                      }">
      <img class="logo ml-4" :src="logoURL" alt="logo da prefeitura" border="0" />
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <h3 class="mr-3">|</h3>
      <router-link :to="homePath" class="navbar-brand d-none d-sm-inline-block">
        <h4>
          {{ sigla }}
        </h4>
      </router-link>
      <div class="ml-auto" v-if="ambiente === 'dev' || ambiente === 'hml'" >
           <h4> 
              <b>
                 ( Homologação )
              </b>
           </h4>   
      </div>  
      <b-navbar-nav class="ml-auto">
        <router-link class="px-3" v-show="useCase" :to="homePath">
          <b-button variant="outline-secondary">
            <b-icon icon="arrow-return-left" variant="dark" />
            Voltar
          </b-button>
        </router-link>
        <b-nav-item-dropdown right v-if="this.$store.getters.userInfo.origem === 'AD' && casosExigenciaPermissaoAutorizadosUsuario.length > 0">
          <template #button-content>
            Manutenção
          </template>
          <b-dropdown-item :to="{name: 'USC.21.021'}" v-if="temPermissaoAcesso('USC.21.021') || this.$store.getters.userInfo.preferred_username ==='pbes00006150'">
            Restringir tributo
          </b-dropdown-item>
          <b-dropdown-item :to="{name: 'USC.21.011'}" v-if="temPermissaoAcesso('USC.21.011')">
            Manutenção Perguntas Frequentes
          </b-dropdown-item>          
        </b-nav-item-dropdown>
        <div v-show="primeiroNome !== 'Anônimo'">
          <b-nav-item-dropdown right>
            <template #button-content>
              <b-icon icon="person-fill" font-scale="1.5"></b-icon>
              <em>{{ primeiroNome }}</em>
            </template>
            <b-dropdown-item @click="logout">
              <i aria-hidden="true" class="fa fa-sign-out"></i>
              Sair
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </div>
      </b-navbar-nav>
    </b-navbar>

    <router-view></router-view>

    <rodape class="mt-auto" :logoURL="logoURL" :versao="versao"></rodape>
  </div>
</template>

<script>
import constantes from "../constants/index";

export default {
  data() {
    return {
      mensagens: [],
      logoURL: process.env.VUE_APP_BASE_URL + "imgs/logomarcaPBH.jpeg",
      origemAcesso: "",
      casosDeUsoQueExigemPermissaoAcesso: ["USC.21.021",  "USC.21.011"],
      casosExigenciaPermissaoAutorizadosUsuario: [],
    };
  },
  methods: {
    logout() {
      this.$store.commit(
        "SET_REDIRECT_URL_LOGOUT",
        window.envJson.url_frontend
      );
      this.$store.dispatch("LOGOUT_REQUEST");
    },
    async checarPermissao() {
      this.casosExigenciaPermissaoAutorizadosUsuario = [];
      try {
        /// RETORNA TODOS OS CASOS QUE TEM PERMISSAO ACESSO PARA O USUARIO
        await this.$axios.post(this.$env.url_backend + constantes.casosPermissaoAcesso, {
          listaCasoUso: this.casosDeUsoQueExigemPermissaoAcesso,
          usuario: this.userName,
        })
        .then((response) => {
          this.casosExigenciaPermissaoAutorizadosUsuario = response.data;
        })
        } catch (error) {
          console.error("Erro ao verificar permissao:", error);
        }
    },
    temPermissaoAcesso(casoDeUso) {
      return this.casosExigenciaPermissaoAutorizadosUsuario.includes(casoDeUso);
    },
  },

  computed: {
    sigla() {
      return process.env.MIX_APP_SIGLA || process.env.VUE_APP_SIGLA;
    },

    ambiente() {
      return window.envJson.environment;
    },

    homePath() {
      return "/";
    },

    useCase() {
      const casoDeUso = this.$route.name !== "home";
      return casoDeUso;
    },

    versao() {
      return process.env.MIX_APP_VERSAO || process.env.VUE_APP_VERSAO;
    },

    primeiroNome() {
      if (this.$store.getters.token) {
        return this.$store.getters.userInfo.given_name;
      } else {
        return "Anônimo";
      }
    },

    origem() {
      if (this.$store.getters.token) {
        return this.$store.getters.userInfo.origem;
      } else {
        return "";
      }
    },

    matricula() {
      if (this.$store.getters.token) {
        return this.$store.getters.userInfo.preferred_username;
      } else {
        return "";
      }
    },
  },
  async beforeMount() {
    this.userName = this.$store.getters.userInfo.preferred_username;
    this.origemAcesso = this.$store.getters.userInfo.origem;
    this.origemNome = this.$store.getters.userInfo.name;
    if (this.origemAcesso === 'AD') {
      await this.checarPermissao();
    }
  },
};
</script>

<style>
.conteudo {
  max-width: 100%;
  min-width: 100%;
  padding-bottom: 15px;
  padding-top: 15px;
  display: flex;
  flex-direction: column;
}

.logo {
  max-width: 165px;
}

.navbar {
  background-color: #ffffff !important;
}

.nav-link {
  display: block;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 400;
  /* padding: 0.5rem 1rem; */
}

.navbar-amarela {
  background-color:  #f9d76f !important;
}

.navbar-branca {
  background-color: #ffffff !important;
}
</style>
